import * as React from "react";
import uuid from "uuid/v4";
import { DocumentDispatch } from "../components/DocumentProvider";
const {
  useContext,
  useEffect,
  useState,
  useMemo
} = React;

const useProp = passedParams => {
  // Default parameters; can be overwritten
  const params = {
    show: true,
    ...passedParams
  }; // Setting ID for component (unique to this instance and will change for
  // the same component when dismounted and remounted)

  const id = useMemo(() => uuid(), []); // Getting the dispatch function to change the panel context state

  const [state, setState] = useState(params.value);
  const dispatch = useContext(DocumentDispatch); // Error out if the hook is used without proper context

  if (!dispatch) {
    throw "The useProp hook must be used inside of the PanelContext component";
  }

  const updateState = value => {
    // TODO: better syntax and type checking for validate function
    // also: sensible defaults (for example, numbers not letting non-numbers)
    if (params.validate) {
      if (params.validate(value) == true) {
        setState(value); // Sets the local state used by the component

        return dispatch({
          type: "UPDATE",
          id,
          value
        }); // Also updates the value
      }

      return;
    }

    setState(value); // Sets the local state used by the component

    return dispatch({
      type: "UPDATE",
      id,
      value
    }); // Also updates the value
  };

  useEffect(() => {
    // Add the component to the context store on mount
    dispatch({
      type: "ADD",
      component: { ...params,
        id,
        setComponentState: updateState
      }
    });
    return () => {
      // And remove it using the created id on unmount
      dispatch({
        type: "REMOVE",
        id
      });
    };
  }, []); // Only run on mount of component
  // Return the set state
  // TODO: Figure out a way to do better type checking for the updateState function depending on the
  // type of value passed in the params (i.e. warn people when trying to update a boolean with a string)

  const returnVal = [state, updateState];
  return returnVal;
};

export default useProp;